import { useMediaQuery } from "react-responsive";
export default function PageHeading(props) {
  const isBigScreen = useMediaQuery({ query: "(min-width: 1000px)" });

  return (
    <div
      className="page-headings"
      style={{
        backgroundImage: `url(https://spagnoladmin.spagnolcompany.it${props.img})`,
      }}
    >
      {!isBigScreen && (
        <img src={`https://spagnoladmin.spagnolcompany.it${props.img}`} />
      )}
    </div>
  );
}
